/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import {
    UiTableCell,
    UiTableRow,
} from 'components/Ui/UiTable'
import Dates from 'utils/Dates'
import { DATE_FORMATS } from 'constants/DateFormats'

export interface ActivityItem {
    id: number | string
    type: 'lead' | 'offer' | 'booking'
    date: string
    title: string
    status: string
}

interface CompanyActivityLogItemProps {
    activity: ActivityItem
}

const CompanyActivityLogItem: React.FC<CompanyActivityLogItemProps> = ({
    activity,
}) => {
    const { t } = useTranslation()

    const getTypeBadgeClass = (type: string) => {
        switch (type) {
            case 'lead':
                return 'bg-blue-100 text-blue-800'
            case 'offer':
                return 'bg-purple-100 text-purple-800'
            case 'booking':
                return 'bg-green-100 text-green-800'
            default:
                return 'bg-gray-100 text-gray-800'
        }
    }

    return (
        <UiTableRow className="CompanyActivityLogItem">
            <UiTableCell>
                {activity.date
                    ? Dates.date(
                          new Date(activity.date),
                          '-',
                          DATE_FORMATS.DATE_TIME
                      )
                    : '-'}
            </UiTableCell>
            <UiTableCell>
                <span
                    className={clsx(
                        'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
                        getTypeBadgeClass(activity.type)
                    )}
                >
                    {t(
                        activity.type.charAt(0).toUpperCase() +
                            activity.type.slice(1)
                    )}
                </span>
            </UiTableCell>
            <UiTableCell className="font-medium">{activity.title}</UiTableCell>
            <UiTableCell>{activity.status}</UiTableCell>
        </UiTableRow>
    )
}

export default CompanyActivityLogItem
